import script from "./ResetPasswordOtp.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPasswordOtp.vue?vue&type=script&setup=true&lang=js"

import "./ResetPasswordOtp.vue?vue&type=style&index=0&id=5f39fb50&lang=css"

const __exports__ = script;

export default __exports__